import defaultImage_DEV_TYPE_P1_ARIANE from '../../../assets/images/devices/default/DEV_TYPE_P1_ARIANE.png';
import defaultImage_DEV_TYPE_P1V30_CHARGER from '../../../assets/images/devices/default/DEV_TYPE_P1V30_CHARGER.png';
import defaultImage_DEV_TYPE_P1V30_HOLDER from '../../../assets/images/devices/default/DEV_TYPE_P1V30_HOLDER.png';
import defaultImage_DEV_TYPE_P1V30M from '../../../assets/images/devices/default/DEV_TYPE_P1V30M.png';
import defaultImage_DEV_TYPE_P1V31_CHARGER from '../../../assets/images/devices/default/DEV_TYPE_P1V31_CHARGER.png';
import defaultImage_DEV_TYPE_P1V31_HOLDER from '../../../assets/images/devices/default/DEV_TYPE_P1V31_HOLDER.png';
import defaultImage_DEV_TYPE_P1V31_ORIGINALS_CHARGER from '../../../assets/images/devices/default/DEV_TYPE_P1V31_ORIGINALS_CHARGER.png';
import defaultImage_DEV_TYPE_P1V31_ORIGINALS_HOLDER from '../../../assets/images/devices/default/DEV_TYPE_P1V31_ORIGINALS_HOLDER.png';
import defaultImage_DEV_TYPE_P1V31M from '../../../assets/images/devices/default/DEV_TYPE_P1V31M.png';
import defaultImage_DEV_TYPE_P1V40C_CHARGER from '../../../assets/images/devices/default/DEV_TYPE_P1V40C_CHARGER.png';
import defaultImage_DEV_TYPE_P1V40C_HOLDER_CONTROL from '../../../assets/images/devices/default/DEV_TYPE_P1V40C_HOLDER_CONTROL.png';
import defaultImage_DEV_TYPE_P1V40D_CONTROL from '../../../assets/images/devices/default/DEV_TYPE_P1V40D_CONTROL.png';
import defaultImage_DEV_TYPE_P1V40V_CHARGER from '../../../assets/images/devices/default/DEV_TYPE_P1V40V_CHARGER.png';
import defaultImage_DEV_TYPE_P1V40V_HOLDER_CONTROL from '../../../assets/images/devices/default/DEV_TYPE_P1V40V_HOLDER_CONTROL.png';
import defaultImage_DEV_TYPE_P1V41J_CONTROL from '../../../assets/images/devices/default/DEV_TYPE_P1V41J_CONTROL.png';
import defaultImage_DEV_TYPE_P1V41M_CHARGER from '../../../assets/images/devices/default/DEV_TYPE_P1V41M_CHARGER.png';
import defaultImage_DEV_TYPE_P1V41M_HOLDER_CONTROL from '../../../assets/images/devices/default/DEV_TYPE_P1V41M_HOLDER_CONTROL.png';
import defaultImage_DEV_TYPE_P1V41P_CHARGER from '../../../assets/images/devices/default/DEV_TYPE_P1V41P_CHARGER.png';
import defaultImage_DEV_TYPE_P1V41P_HOLDER_CONTROL from '../../../assets/images/devices/default/DEV_TYPE_P1V41P_HOLDER_CONTROL.png';
import defaultImage_DEV_TYPE_P4_M3_G2_iqos_title from '../../../assets/images/devices/default/DEV_TYPE_P4_M3_G2_IQOS_TITLE.png';
import defaultImage_DEV_TYPE_P4_M3_G2_veev_title from '../../../assets/images/devices/default/DEV_TYPE_P4_M3_G2_VEEV_TITLE.png';
import defaultImage_DEV_TYPE_V24P_CHARGER from '../../../assets/images/devices/default/DEV_TYPE_V24P_CHARGER.png';
import defaultImage_DEV_TYPE_V24P_HOLDER from '../../../assets/images/devices/default/DEV_TYPE_V24P_HOLDER.png';
import DEVICE_TYPES from '../../enums/device/deviceTypes';
import marketTypeService from '../../services/marketTypeService';
import * as localizationKeys from '../localization/localizationKeys';

type TData = {
    [key in DEVICE_TYPES]?: IDeviceDataTypeOptions | null;
};

export interface IDeviceDataTypeOptions {
    defaultImageSrc?: string;
    description: string;
    isHolder?: boolean;
    nameKey: string;
    type: string;
    fullType: string;
    isMono?: boolean;
    deviceModel?: string;
}

const getDeviceTypesData = (): TData => {
    const data: TData = {
        [DEVICE_TYPES.DEV_TYPE_UNKNOWN]: null,
        [DEVICE_TYPES.DEV_TYPE_V24P_CHARGER]: {
            defaultImageSrc: defaultImage_DEV_TYPE_V24P_CHARGER,
            description: 'IQOS 2.4 Plus Charger',
            nameKey: localizationKeys.DEVICE_ORDINARY_NAME,
            deviceModel: 'IQOS 2.4 Plus',
            type: DEVICE_TYPES.DEV_TYPE_P1,
            fullType: DEVICE_TYPES.DEV_TYPE_V24P_CHARGER,
        },
        [DEVICE_TYPES.DEV_TYPE_V24P_HOLDER]: {
            defaultImageSrc: defaultImage_DEV_TYPE_V24P_HOLDER,
            description: 'IQOS 2.4 Plus Holder',
            isHolder: true,
            nameKey: localizationKeys.ABOUT_DEVICE_ORDINARY_HOLDER_NAME,
            type: DEVICE_TYPES.DEV_TYPE_P1,
            fullType: DEVICE_TYPES.DEV_TYPE_V24P_HOLDER,
        },
        [DEVICE_TYPES.DEV_TYPE_P1V30_CHARGER]: {
            defaultImageSrc: defaultImage_DEV_TYPE_P1V30_CHARGER,
            description: 'IQOS 3.0 Charger (Cortez)',
            nameKey: localizationKeys.DEVICE_CORTEZ_NAME,
            deviceModel: 'IQOS 3.0',
            type: DEVICE_TYPES.DEV_TYPE_P1,
            fullType: DEVICE_TYPES.DEV_TYPE_P1V30_CHARGER,
        },
        [DEVICE_TYPES.DEV_TYPE_P1V30_HOLDER]: {
            defaultImageSrc: defaultImage_DEV_TYPE_P1V30_HOLDER,
            description: 'IQOS 3.0 Holder (Cortez)',
            isHolder: true,
            nameKey: localizationKeys.ABOUT_DEVICE_CORTEZ_HOLDER_NAME,
            type: DEVICE_TYPES.DEV_TYPE_P1,
            fullType: DEVICE_TYPES.DEV_TYPE_P1V30_HOLDER,
        },
        [DEVICE_TYPES.DEV_TYPE_P1V30M]: {
            defaultImageSrc: defaultImage_DEV_TYPE_P1V30M,
            description: 'IQOS 3.0 Multi',
            isMono: true,
            nameKey: localizationKeys.DEVICE_VESPUCCI_NAME,
            deviceModel: 'IQOS 3.0 Multi',
            type: DEVICE_TYPES.DEV_TYPE_P1,
            fullType: DEVICE_TYPES.DEV_TYPE_P1V30M,
        },
        [DEVICE_TYPES.DEV_TYPE_P1V31M]: {
            defaultImageSrc: defaultImage_DEV_TYPE_P1V31M,
            description: 'IQOS Originals One',
            isMono: true,
            nameKey: localizationKeys.DEVICE_ORIGINALS_ONE_NAME,
            deviceModel: 'IQOS Originals One',
            type: DEVICE_TYPES.DEV_TYPE_P1,
            fullType: DEVICE_TYPES.DEV_TYPE_P1V31M,
        },
        [DEVICE_TYPES.DEV_TYPE_P1V31_CHARGER]: {
            defaultImageSrc: defaultImage_DEV_TYPE_P1V31_CHARGER,
            description: 'IQOS 3.1 Charger (Soyuz)',
            nameKey: localizationKeys.DEVICE_SOYUZ_NAME,
            deviceModel: 'IQOS 3.1',
            type: DEVICE_TYPES.DEV_TYPE_P1,
            fullType: DEVICE_TYPES.DEV_TYPE_P1V31_CHARGER,
        },
        [DEVICE_TYPES.DEV_TYPE_P1V31_HOLDER]: {
            defaultImageSrc: defaultImage_DEV_TYPE_P1V31_HOLDER,
            description: 'IQOS 3.1 Holder (Soyuz)',
            isHolder: true,
            nameKey: localizationKeys.ABOUT_DEVICE_SOYUZ_HOLDER_NAME,
            type: DEVICE_TYPES.DEV_TYPE_P1,
            fullType: DEVICE_TYPES.DEV_TYPE_P1V31_HOLDER,
        },
        [DEVICE_TYPES.DEV_TYPE_P1V31_ORIGINALS_CHARGER]: {
            defaultImageSrc: defaultImage_DEV_TYPE_P1V31_ORIGINALS_CHARGER,
            description: 'IQOS Originals Duo Charger',
            nameKey: localizationKeys.DEVICE_ORIGINALS_DUO_NAME,
            deviceModel: 'IQOS Originals Duo',
            type: DEVICE_TYPES.DEV_TYPE_P1,
            fullType: DEVICE_TYPES.DEV_TYPE_P1V31_ORIGINALS_CHARGER,
        },
        [DEVICE_TYPES.DEV_TYPE_P1V31_ORIGINALS_HOLDER]: {
            defaultImageSrc: defaultImage_DEV_TYPE_P1V31_ORIGINALS_HOLDER,
            description: 'IQOS Originals Duo Holder',
            isHolder: true,
            nameKey: localizationKeys.ABOUT_DEVICE_ORIGINALS_DUO_HOLDER_NAME,
            type: DEVICE_TYPES.DEV_TYPE_P1,
            fullType: DEVICE_TYPES.DEV_TYPE_P1V31_ORIGINALS_HOLDER,
        },
        [DEVICE_TYPES.DEV_TYPE_P4_M3_G1]: {
            description: 'IQOS P4 gen. 1 (Mesh)',
            isMono: true,
            nameKey: 'Mesh',
            deviceModel: 'IQOS VEEV',
            type: DEVICE_TYPES.DEV_TYPE_P4,
            fullType: DEVICE_TYPES.DEV_TYPE_P4_M3_G1,
        },
        [DEVICE_TYPES.DEV_TYPE_P4_M3_G2]: {
            defaultImageSrc: marketTypeService.getP4DefaultImageByMarket(
                defaultImage_DEV_TYPE_P4_M3_G2_iqos_title,
                defaultImage_DEV_TYPE_P4_M3_G2_veev_title
            ),
            description: 'IQOS P4 gen. 2 (Titan)/(VEEV)',
            isHolder: false,
            isMono: true,
            nameKey: localizationKeys.DEVICE_TITAN_NAME,
            deviceModel: 'IQOS VEEV',
            type: DEVICE_TYPES.DEV_TYPE_P4,
            fullType: DEVICE_TYPES.DEV_TYPE_P4_M3_G2,
        },
        [DEVICE_TYPES.DEV_TYPE_P1_ARIANE]: {
            defaultImageSrc: defaultImage_DEV_TYPE_P1_ARIANE,
            description: 'P1 Ariane (Mono)',
            isHolder: false,
            isMono: true,
            nameKey: localizationKeys.DEVICE_ARIANE_NAME,
            deviceModel: 'IQOS Ariane (Mono)',
            type: DEVICE_TYPES.DEV_TYPE_P1,
            fullType: DEVICE_TYPES.DEV_TYPE_P1_ARIANE,
        },
        [DEVICE_TYPES.DEV_TYPE_P1V40V_CHARGER]: {
            defaultImageSrc: defaultImage_DEV_TYPE_P1V40V_CHARGER,
            description: 'IQOS P1V40 Charger',
            nameKey: localizationKeys.DEVICE_P1V40_NAME,
            deviceModel: 'IQOS Iluma Prime',
            type: DEVICE_TYPES.DEV_TYPE_P1_V4,
            fullType: DEVICE_TYPES.DEV_TYPE_P1V40V_CHARGER,
        },
        [DEVICE_TYPES.DEV_TYPE_P1V40V_HOLDER_CONTROL]: {
            defaultImageSrc: defaultImage_DEV_TYPE_P1V40V_HOLDER_CONTROL,
            description: 'IQOS P1V40 Holder',
            isHolder: true,
            nameKey: localizationKeys.ABOUT_DEVICE_P1V40_HOLDER_NAME,
            type: DEVICE_TYPES.DEV_TYPE_P1_V4,
            fullType: DEVICE_TYPES.DEV_TYPE_P1V40V_HOLDER_CONTROL,
        },
        [DEVICE_TYPES.DEV_TYPE_P1V40C_CHARGER]: {
            defaultImageSrc: defaultImage_DEV_TYPE_P1V40C_CHARGER,
            description: 'IQOS P1V40C Charger',
            nameKey: localizationKeys.DEVICE_P1V40M_NAME,
            deviceModel: 'IQOS Iluma Mid',
            type: DEVICE_TYPES.DEV_TYPE_P1_V4,
            fullType: DEVICE_TYPES.DEV_TYPE_P1V40C_CHARGER,
        },
        [DEVICE_TYPES.DEV_TYPE_P1V40C_HOLDER_CONTROL]: {
            defaultImageSrc: defaultImage_DEV_TYPE_P1V40C_HOLDER_CONTROL,
            description: 'IQOS P1V40C Holder',
            isHolder: true,
            nameKey: localizationKeys.ABOUT_DEVICE_P1V40M_HOLDER_NAME,
            type: DEVICE_TYPES.DEV_TYPE_P1_V4,
            fullType: DEVICE_TYPES.DEV_TYPE_P1V40C_HOLDER_CONTROL,
        },
        [DEVICE_TYPES.DEV_TYPE_P1V40D_CONTROL]: {
            defaultImageSrc: defaultImage_DEV_TYPE_P1V40D_CONTROL,
            description: 'IQOS P1V40 (Delta)',
            isMono: true,
            nameKey: localizationKeys.DEVICE_P1V40D_NAME,
            deviceModel: 'IQOS Iluma One',
            type: DEVICE_TYPES.DEV_TYPE_P1_V4,
            fullType: DEVICE_TYPES.DEV_TYPE_P1V40D_CONTROL,
        },
        [DEVICE_TYPES.DEV_TYPE_P1V41P_CHARGER]: {
            defaultImageSrc: defaultImage_DEV_TYPE_P1V41P_CHARGER,
            description: 'IQOS P1V41P Charger',
            nameKey: localizationKeys.DEVICE_P1V41P_NAME,
            deviceModel: 'IQOS Iluma i Prime',
            type: DEVICE_TYPES.DEV_TYPE_P1_V4,
            fullType: DEVICE_TYPES.DEV_TYPE_P1V41P_CHARGER,
        },
        [DEVICE_TYPES.DEV_TYPE_P1V41P_HOLDER_CONTROL]: {
            defaultImageSrc: defaultImage_DEV_TYPE_P1V41P_HOLDER_CONTROL,
            description: 'IQOS P1V41P Holder',
            isHolder: true,
            nameKey: localizationKeys.ABOUT_DEVICE_P1V41P_HOLDER_NAME,
            type: DEVICE_TYPES.DEV_TYPE_P1_V4,
            fullType: DEVICE_TYPES.DEV_TYPE_P1V41P_HOLDER_CONTROL,
        },
        [DEVICE_TYPES.DEV_TYPE_P1V41M_CHARGER]: {
            defaultImageSrc: defaultImage_DEV_TYPE_P1V41M_CHARGER,
            description: 'IQOS P1V41M Charger',
            nameKey: localizationKeys.DEVICE_P1V41M_NAME,
            deviceModel: 'IQOS Iluma i Mid',
            type: DEVICE_TYPES.DEV_TYPE_P1_V4,
            fullType: DEVICE_TYPES.DEV_TYPE_P1V41M_CHARGER,
        },
        [DEVICE_TYPES.DEV_TYPE_P1V41M_HOLDER_CONTROL]: {
            defaultImageSrc: defaultImage_DEV_TYPE_P1V41M_HOLDER_CONTROL,
            description: 'IQOS P1V41M Holder',
            isHolder: true,
            nameKey: localizationKeys.ABOUT_DEVICE_P1V41M_HOLDER_NAME,
            type: DEVICE_TYPES.DEV_TYPE_P1_V4,
            fullType: DEVICE_TYPES.DEV_TYPE_P1V41M_HOLDER_CONTROL,
        },
        [DEVICE_TYPES.DEV_TYPE_P1V41J_CONTROL]: {
            defaultImageSrc: defaultImage_DEV_TYPE_P1V41J_CONTROL,
            description: 'IQOS P1V41J Charger',
            isMono: true,
            nameKey: localizationKeys.DEVICE_P1V41J_NAME,
            deviceModel: 'IQOS Iluma i One',
            type: DEVICE_TYPES.DEV_TYPE_P1_V4,
            fullType: DEVICE_TYPES.DEV_TYPE_P1V41J_CONTROL,
        },
    };

    return data;
};

export {getDeviceTypesData};
